import { map, Observable, of } from "rxjs";
import { environment } from "src/environments/environment";

import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { SearchItem } from "../domains/searchItem";

@Injectable({
  providedIn: "root",
})
export class SearchService {
  public url = environment.apiUrl + "/search";
  private readonly MIN_QUERY_LENGTH = 2;
  private readonly MAX_QUERY_LENGTH = 80;

  constructor(private http: HttpClient) {}

  getSearch(query: string, limit_items: number = 30): Observable<SearchItem[]> {
    const sanitizedQuery = this.sanitizeQuery(query);
    if (sanitizedQuery.length < this.MIN_QUERY_LENGTH) {
      return of([]);
    }

    const params = new HttpParams().set("query", sanitizedQuery).set("limit_items", limit_items);
    return this.http
      .get<SearchItem[]>(this.url, {
        params: params,
      })
      .pipe(map(SearchItem.createInstances));
  }

  sanitizeQuery(query: string): string {
    return (query || "").replace(/\s+/g, " ").trim().slice(0, this.MAX_QUERY_LENGTH);
  }
}
